import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrollToTop";
import FormattedText, { withEllipsis } from "./formattedText";
import { useDevotionals, DEFAULT_CARD_IMG } from "../data/devotionals";

const DevotionalPreview = () => {
  const { entries, loading, error } = useDevotionals();

  if (loading) return <p>Loading entries…</p>;
  if (error) return <p>{error}</p>;
  if (entries.length === 0) return null;

  return (
    <>
      <div className="dev-previews-container">
        {entries.slice(0, 3).map((devotional) => (
          <div className="devotional-preview-container" key={devotional.id}>
            <img src={devotional.coverImage || DEFAULT_CARD_IMG} alt="" />
            <h3>{devotional.title}</h3>
            <div>
              <FormattedText text={withEllipsis(devotional.introParagraph)} />
            </div>
            <Link
              to={`/exegesis/${devotional.slug || devotional.id}`}
              onClick={scrollToTop}
            >
              <button>Read more</button>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default DevotionalPreview;